import * as Types from '@/types/schema.generated'

export const GenderToString: Record<Types.Gender, string> = {
  [Types.Gender.Male]: '男性',
  [Types.Gender.Female]: '女性',
  [Types.Gender.Other]: 'その他',
  [Types.Gender.NoAnswer]: '回答しない',
}
